import(/* webpackMode: "eager" */ "/srv/stiga-configurator-3d/client/app/error.tsx");
